import { demo676 } from './demo-676'
import { demoNorthfield } from './demo-northfield'
import { neutralDemo } from './neutral'
import type { TenantFixture } from './types'

export type { TenantFixture } from './types'

/** The demo tenants, first one opened by default. */
export const DEMO_TENANTS: readonly TenantFixture[] = [demo676, demoNorthfield]

/**
 * What the real API's client shows where no endpoint exists yet. It names no
 * business, because it is shown to whichever tenant is signed in.
 */
export const NEUTRAL_DEMO_TENANT: TenantFixture = neutralDemo
